import React, { useCallback } from "react";
import styled from "styled-components";
import copy from "copy-to-clipboard";
import { Slide, toast } from "react-toastify";
import QuestionLinkIcon from "../../../../../common/assets/icons/admin_page_icons/question_link_icon";

const ShareUserQuestionContainer = styled.div`
  ${({ unselected }) =>
    !unselected &&
    `
   cursor: pointer;
   transition: 0.2s;

   &:hover {
     transform: scale(1.12);
  }
`}
`;

const ShareUserQuestion = ({ question, unselected }) => {
  const showNotification = () => {
    toast("Ссылка скопирована!", {
      position: "top-left",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      closeButton: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
      pauseOnFocusLoss: false,
      transition: Slide,
    });
  };

  const copyToClipboard = useCallback(
    (event) => {
      if (!unselected) {
        event.stopPropagation();
        const host = window.location.origin;

        const questionUrl = `${host}/admin/questions?q=${question._id}`;

        const isCopied = copy(questionUrl);

        if (isCopied) {
          showNotification();
        } else {
          console.error("Не удалось скопировать.");
          alert("Ошибка при копировании");
        }
      }
    },
    [question, unselected]
  );

  return (
    <ShareUserQuestionContainer
      unselected={unselected}
      onClick={copyToClipboard}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <QuestionLinkIcon />
    </ShareUserQuestionContainer>
  );
};

export default ShareUserQuestion;
